import { jsx as t, jsxs as a } from "react/jsx-runtime";
import { useRef as B, useState as W, useEffect as C, useCallback as x } from "react";
import { Avatar as $ } from "../../../atoms/Avatar/Avatar.es.js";
import { IconButton as y } from "../../../atoms/Button/Button.es.js";
import { Paragraph as I } from "../../../atoms/Paragraph/Paragraph.es.js";
import { Badge as j } from "../../Badge/Badge.es.js";
import { useMultiStyleConfig as L, chakra as o, Skeleton as d } from "@chakra-ui/react";
import { InfoIcon as w, TrashIcon as G, CloseIcon as M } from "../../../icons/index.es.js";
const b = 350, O = (l) => {
  const r = L("SavedListItemEdit"), { creator: e, isLoading: S, list: c, onNoteChange: h, onRemove: u, ...v } = l, { avatar: N, name: g, isInList: R, defaultNote: i = "" } = e, { id: m, name: z } = c, _ = B({ id: null }), [s, p] = W(e.note ?? i ?? "");
  C(() => {
    _.current.id !== m && (_.current.id = m);
  }, [m]);
  const k = x((n) => {
    const f = n.target.value, A = {
      ...e,
      dirty: n.target.value !== i,
      note: f
    };
    p(f), h(c, A);
  }, []), E = x(() => {
    const n = {
      ...e,
      dirty: i !== "",
      note: ""
    };
    p(""), h(c, n);
  }, []);
  return C(() => {
    p(e.note ?? i ?? "");
  }, [e.note, i]), S ? /* @__PURE__ */ t(P, { ...v }) : /* @__PURE__ */ a(o.div, { __css: r.root, "data-testid": `item-${e.id}`, ...v, children: [
    /* @__PURE__ */ t($, { __css: r.avatar, src: N, alt: g, variant: "square", size: "lg" }),
    /* @__PURE__ */ a(o.div, { __css: r.content, children: [
      /* @__PURE__ */ a(o.div, { __css: r.header, children: [
        /* @__PURE__ */ t(I, { __css: r.paragraph, fontWeight: "medium", size: "lg", children: g }),
        R && /* @__PURE__ */ t(j, { size: "xs", label: "Already on the list", icon: /* @__PURE__ */ t(w, {}), variant: "info" }),
        !!u && /* @__PURE__ */ t(
          y,
          {
            "aria-label": "Remove creator from list",
            "data-testid": `remove-${e.id}`,
            icon: /* @__PURE__ */ t(G, {}),
            marginLeft: "auto",
            onClick: () => u(e),
            size: "sm",
            variant: "transparent"
          }
        )
      ] }),
      /* @__PURE__ */ a(o.div, { __css: r.textareaGroup, "data-replicated-value": s, "data-group": !0, children: [
        /* @__PURE__ */ t(
          o.textarea,
          {
            __css: r.textarea,
            maxLength: b,
            onChange: k,
            placeholder: `Add a note to ${z}`,
            rows: 1,
            value: s
          }
        ),
        !!s.length && /* @__PURE__ */ t(
          y,
          {
            __css: r.textareaClear,
            "aria-label": "Clear",
            icon: /* @__PURE__ */ t(M, {}),
            size: "sm",
            variant: "transparent",
            onClick: E
          }
        )
      ] }),
      /* @__PURE__ */ a(I, { color: "primary.300", size: "md", children: [
        s.length ?? 0,
        "/",
        b,
        " characters"
      ] })
    ] })
  ] });
}, P = (l) => {
  const r = L("SavedListItemEdit");
  return /* @__PURE__ */ a(o.div, { __css: r.root, ...l, children: [
    /* @__PURE__ */ t(
      d,
      {
        __css: r.avatar,
        borderRadius: "radius-100",
        boxSize: "48px",
        endColor: "primary.100",
        startColor: "primary.50"
      }
    ),
    /* @__PURE__ */ a(o.div, { __css: r.content, children: [
      /* @__PURE__ */ t(
        d,
        {
          maxWidth: "96px",
          height: "16px",
          borderRadius: "radius-50",
          endColor: "primary.100",
          startColor: "primary.50",
          marginBottom: 2.5
        }
      ),
      /* @__PURE__ */ t(
        d,
        {
          width: "100%",
          height: "50px",
          borderRadius: "radius-50",
          endColor: "primary.100",
          startColor: "primary.50",
          marginBottom: 2.5
        }
      ),
      /* @__PURE__ */ t(
        d,
        {
          maxWidth: "24px",
          height: "8px",
          borderRadius: "radius-50",
          endColor: "primary.100",
          startColor: "primary.50"
        }
      )
    ] })
  ] });
};
export {
  O as SavedListItemEdit,
  P as SavedListItemEditSkeleton
};
//# sourceMappingURL=SavedListItemEdit.es.js.map
